import type { ForwardedRef, ForwardRefExoticComponent, RefAttributes } from 'react'
import { forwardRef, PropsWithChildren } from 'react'
import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps, Theme } from '@mui/material'
import { SystemStyleObject } from '@mui/system'

export type AvatarProps = PropsWithChildren<
  MuiAvatarProps & {
    onClick?: () => void
    isLarge?: boolean
  }
>

const styles: Record<string, SystemStyleObject<Theme>> = {
  avatar: {
    width: '32px',
    height: '32px',
    color: '#00000',
    backgroundColor: '#76C4DC',
    fontWeight: 'bold',
    fontSize: '0.90rem',
    textDecoration: 'none',
  },
  large: {
    width: '100px',
    height: '100px',
    fontSize: '2.70rem',
  },
}

export const Avatar: ForwardRefExoticComponent<Omit<AvatarProps, 'ref'> & RefAttributes<HTMLDivElement | null>> =
  forwardRef(({ onClick, isLarge = false, ...rest }: AvatarProps, ref: ForwardedRef<HTMLDivElement | null>) => (
    <MuiAvatar
      onClick={onClick}
      {...rest}
      ref={ref}
      sx={{
        ...styles.avatar,
        cursor: onClick ? 'pointer' : undefined,
        ...(isLarge ? styles.large : {}),
      }}
    />
  ))
